import ko from "knockout";
import template from "./index.html";
import PushService from "../../PushService";
import { 
	eventSubscribeGet,
    eventSubscribeTelephone,
	eventSubscribeTelephoneCode,
    eventSubscribeEmail,
	eventSubscribeEmailCode,
    eventSubscribePush,
} from 'api';
import {currentBrowser} from "../../tools";

(function() {
	var pushService = new PushService();

	var viewModel = function(params) {
		var self = this;
		var $app = params.$app;

		function isPushAllowed() {
			if('Notification' in window) {
				if (currentBrowser.isChrome() >= 50) return true;
				if (currentBrowser.isFirefox() >= 44) return true;
				if (currentBrowser.isOpera() >= 37) return true;
			}
			return false;
		}

		self.$locale = $app.require('locale');

		self.isShow = params.isShow;
		self.hide = params.hide;
		self.isDataLoaded = ko.observable(false);

		self.types = ko.computed(function() {
			var types = [
				'calendar',
//				'google',
			];
			if(true) {
				types.push('email');
			}
			if($app.event().moduleBranding.allowSMSNotifications()) {
				types.push('sms');
			}
			if(isPushAllowed()) {
				types.push('push');
			}
			return types;
		});
		self.selectedType = ko.observable(self.types()[0]);
		self.selectType = (type) => self.selectedType(type);

		self.phoneExist = ko.observable();
		self.phone = ko.observable();
		self.phoneConfirmed = ko.observable(false);
		self.sendPhone = (form) => {
			var phone = form.phone.value;
			var data = {
				phone,
				eventKey: $app.event().eventKey(),
			};

			eventSubscribeTelephone(data)
				.then(response => {
					self.phone(response.phone);
					self.phoneConfirmed(response.confirmed);
				})
				.catch(() => alert('Вы указали не верный номер телефона'))
			;
		};
		self.sendPhoneCode = (form) => {
			var code = form.code.value;
			var phone = self.phone();
			var data = {
				phone,
				code,
			};

			eventSubscribeTelephoneCode(data)
				.then(response => {
					self.phone(response.phone);
					self.phoneConfirmed(response.confirmed);
				})
				.catch(() => alert('Указан неверный код'))
			;
		};

		self.emailExist = ko.observable();
		self.email = ko.observable();
		self.emailConfirmed = ko.observable(false);
		self.sendEmail = (form) => {
			var email = form.email.value;
			var data = {
				email,
				eventKey: $app.event().eventKey(),
			};

			eventSubscribeEmail(data)
				.then(response => {
					self.email(response.email);
					self.emailConfirmed(response.confirmed);
				})
				.catch(() => alert('Указан неверный eMail адрес'))
			;
		};
		self.sendEmailCode = (form) => {
			var code = form.code.value;
			var email = self.email();
			var data = {
				email,
				code,
			};

			eventSubscribeEmailCode(data)
				.then(response => {
					self.email(response.email);
					self.emailConfirmed(response.confirmed);
				})
				.catch(() => alert('Указан неверный код'))
			;
		};

		self.pushExist = ko.observable();
		self.push = ko.observable();
		self.pushConfirmed = ko.observable(false);
		self.sendPush = () => {
			pushService.subscribe()
				.then(token => {
					var data = {
						eventKey: $app.event().eventKey(),
						push: token
					};

					eventSubscribePush(data)
						.then(response => {
							self.push(response.push);
							self.pushConfirmed(response.confirmed);
						})
						.catch(({data}) => alert(data?.error?.message))
					;
				});
		};

		self.isShow.subscribe(() => {
			if(!self.isDataLoaded()) {
				eventSubscribeGet($app.event().eventKey())
					.then(response => {
						self.isDataLoaded(true);

						Object.keys(response).forEach(key => {
							var value = response[key];
							if(key === 'subscribe') {
								Object.keys(value).forEach(type => {
									var value = response.subscribe[type];
									if(self[type] && self[`${type}Confirmed`]) {
										self[`${type}`](value);
										self[`${type}Confirmed`](true);
									}
								});
							} else if(self[`${key}Exist`]) {
								self[`${key}Exist`](value);
							}
						})
					})
				;
			}
		});
	};

	ko.components.register('notification-subscribe', {template, viewModel});
})();
